import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { FullPageSpinner } from '../ui/Spinner'

export function OnboardingGuard() {
  const { tenant, isTenantResolved, orphanReason } = useAuthStore()
  const location = useLocation()

  // Wait until membership has actually been resolved before deciding anything,
  // so a legitimate user is never briefly shown the orphan/broken UI while the
  // tenant lookup is still in flight.
  if (!isTenantResolved) return <FullPageSpinner />

  if (!tenant) {
    // Authenticated but no active workspace membership → dedicated fallback.
    if (orphanReason) return <Navigate to="/orphan" replace />
    return <Navigate to="/login" replace />
  }

  if (!tenant.onboarding_completed && !location.pathname.startsWith('/onboarding')) {
    return <Navigate to="/onboarding" replace />
  }

  if (tenant.onboarding_completed && location.pathname.startsWith('/onboarding')) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
